import { supabase, isSupabaseConfigured } from '@/lib/supabase'

export interface WaitlistEntry {
  id: string
  email: string
  created_at: string
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
  utm_term?: string
  referrer?: string
  landing_path?: string
}

export interface WaitlistTrackingData {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_content?: string
  utm_term?: string
  referrer?: string
  landing_path?: string
}

export async function addToWaitlist(
  email: string,
  tracking?: WaitlistTrackingData
): Promise<{ success: boolean; error?: string }> {
  if (!isSupabaseConfigured()) {
    console.log('Waitlist signup (Supabase not configured):', email, tracking)
    return { success: true }
  }

  const { error } = await supabase.from('waitlist').insert({
    email: email.toLowerCase().trim(),
    ...(tracking?.utm_source && { utm_source: tracking.utm_source }),
    ...(tracking?.utm_medium && { utm_medium: tracking.utm_medium }),
    ...(tracking?.utm_campaign && { utm_campaign: tracking.utm_campaign }),
    ...(tracking?.utm_content && { utm_content: tracking.utm_content }),
    ...(tracking?.utm_term && { utm_term: tracking.utm_term }),
    ...(tracking?.referrer && { referrer: tracking.referrer }),
    ...(tracking?.landing_path && { landing_path: tracking.landing_path }),
  })

  if (error) {
    if (error.code === '23505') {
      // Unique constraint violation - email already exists
      return { success: true } // Treat as success, don't reveal if email exists
    }
    console.error('Waitlist error:', error)
    return { success: false, error: 'Something went wrong. Please try again.' }
  }

  return { success: true }
}
